import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const pathsApiRoutes = {
    list: apiDataManagerBaseURL + "paths/",
    listByLine: apiDataManagerBaseURL + "paths/byline/",
    listDraft: apiDataManagerBaseURL + "pathsdraft/",
    listDraftByLine: apiDataManagerBaseURL + "pathsdraft/byline/",
    load: apiDataManagerBaseURL + "paths/",
    copy: apiDataManagerBaseURL + "paths/copy/",
    copyDraft: apiDataManagerBaseURL + "pathsdraft/copy/",
    intervals: apiDataManagerBaseURL + "paths/intervals/",
    intervalsDraft: apiDataManagerBaseURL + "pathsdraft/intervals/",
    notes: apiDataManagerBaseURL + "paths/notes/",
    notesDraft: apiDataManagerBaseURL + "pathsdraft/notes/",
    create: apiDataManagerBaseURL + "paths/",
    createDraft: apiDataManagerBaseURL + "pathsdraft/",
    update: apiDataManagerBaseURL + "paths/",
    updateDraft: apiDataManagerBaseURL + "pathsdraft/",
    delete: apiDataManagerBaseURL + "paths/",
    deleteDraft: apiDataManagerBaseURL + "pathsdraft/"
};

export class PathAPI {
    static list(networkEdition, provider = '') {
        const url = new URL(networkEdition, pathsApiRoutes.list);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static listByLine(networkEdition, lineId, provider = '') {
        const url = new URL(`${networkEdition}/${lineId}`, pathsApiRoutes.listByLine);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static listDraft(draftNetworkEdition, provider = '') {
        const url = `${pathsApiRoutes.listDraft}${draftNetworkEdition}`;

        return API.authenticatedRequest({
            url: '' === provider ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static listByLineDraft(draftNetworkEdition, lineId, provider = '') {
        const url = `${pathsApiRoutes.listDraftByLine}${draftNetworkEdition}/${lineId}`;

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static listByLineWithActiveDraft(networkEdition, draftNetworkEdition, lineId, provider = '') {
        const url = `${pathsApiRoutes.listDraftByLine}${networkEdition}/${draftNetworkEdition}/${lineId}`;

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static load(networkEdition, id) {
        const url = new URL(`${networkEdition}/${id}`, pathsApiRoutes.load);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static copy(networkEdition, path) {
        const url = new URL(networkEdition, pathsApiRoutes.copy);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(path)
        });
    }

    static copyDraft(networkEdition, path) {
        const url = new URL(networkEdition, pathsApiRoutes.copyDraft);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(path)
        });
    }

    static getIntervals(networkEdition, id, provider = '') {
        const url = new URL(`${networkEdition}/${id}`, pathsApiRoutes.intervals);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static getIntervalsDraft(draftNetworkEdition, id, provider = '') {
        const url = new URL(`${draftNetworkEdition}/${id}`, pathsApiRoutes.intervalsDraft);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static getNotes(networkEdition, id, provider = '') {
        const url = new URL(`${networkEdition}/${id}`, pathsApiRoutes.notes);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static getNotesDraft(draftNetworkEdition, id, provider = '') {
        const url = new URL(`${draftNetworkEdition}/${id}`, pathsApiRoutes.notesDraft);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static create(networkEdition, path) {
        const url = new URL(networkEdition, pathsApiRoutes.create);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(path)
        });
    }

    static createDraft(draftNetworkEdition, path) {
        const url = `${pathsApiRoutes.createDraft}${draftNetworkEdition}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(path)
        });
    }

    static update(networkEdition, id, path) {
        const url = new URL(`${networkEdition}/${id}`, pathsApiRoutes.update);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(path)
        });
    }

    static updateDraft(draftNetworkEdition, id, path) {
        const url = `${pathsApiRoutes.updateDraft}${draftNetworkEdition}/${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(path)
        });
    }

    static saveIntervals(networkEdition, id, intervals, provider = '') {
        const url = new URL(`${networkEdition}/${id}`, pathsApiRoutes.intervals);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(intervals)
        });
    }

    static saveIntervalsDraft(draftNetworkEdition, id, intervals, provider = '') {
        const url = new URL(`${draftNetworkEdition}/${id}`, pathsApiRoutes.intervalsDraft);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(intervals)
        });
    }

    

    static saveNotes(networkEdition, id, notes, provider = '') {
        const url = new URL(`${networkEdition}/${id}`, pathsApiRoutes.notes);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(notes)
        });
    }

    static saveNotesDraft(draftNetworkEdition, id, notes, provider = '') {
        const url = new URL(`${draftNetworkEdition}/${id}`, pathsApiRoutes.notesDraft);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(notes)
        });
    }

    static delete(networkEdition, id) {
        const url = new URL(`${networkEdition}/${id}`, pathsApiRoutes.delete);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static deleteDraft(draftNetworkEdition, id) {
        const url = `${pathsApiRoutes.deleteDraft}${draftNetworkEdition}/${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}